<template>
    <api-key-manager :clients="apiClients"
                     :loading="loading"
                     :saving="saving"
                     create-box-help="subpanel-settings-create-api-client"
                     active-clients-box-help="subpanel-settings-active-clients"
                     doc-url="https://documenter.getpostman.com/view/10045385/SWLiZ5sY"
                     @create="create"
                     @delete="deleteClient"
                     @reload="reload"
    ></api-key-manager>
</template>

<script>

    import ApiKeyManager from "../../../../components/UI/ApiKeyManager";
    import {mapState, mapMutations, mapActions} from 'vuex';
    import SubPanel from "../../ts/SubPanel";

    export default {

        props: {
            subPanel: {
                required: true,
                type: SubPanel
            }
        },

        components: {
            ApiKeyManager
        },

        data() {
            return {
                loading: false,
                saving: false,
            }
        },
        computed: {
            ...mapState('SubPanels', [
                'apiClients',
            ]),
        },

        watch: {
            subPanel() {
                this.loadClients();
            }
        },

        methods: {

            ...mapActions('SubPanels', [
                'getApiClients',
                'createApiClient',
                'deleteApiClient'
            ]),

            ...mapMutations('SubPanels', [
                'clearApiClients'
            ]),

            create(payload) {

                this.saving = true;

                this.createApiClient({id: this.subPanel.id, payload: payload})
                    .then(response => {
                        Bus.$emit('flash-message', {message: 'Client created!'});
                    })
                    .catch(error => {
                        Bus.$emit('flash-message', {
                            type: 'error',
                            message: 'OOPS! Creating API client failed for some reason...'
                        });
                    })
                    .finally(() => {
                        this.saving = false;
                    });
            },

            deleteClient(id) {

                this.deleteApiClient({id: this.subPanel.id, clientId: id})
                    .then(response => {
                        Bus.$emit('flash-message', {message: 'API client deleted successfully!'});
                    })
                    .catch(error => {
                        Bus.$emit('flash-message', {type: 'error', message: 'Delete failed for some reason...'});
                    })
            },

            reload() {
                this.loadClients(true);
            },

            loadClients(notify = false) {

                if (!notify) this.clearApiClients();

                if (this.subPanel) {

                    this.loading = true;

                    this.getApiClients(this.subPanel.id)
                        .then(response => {
                            if (notify) {
                                Bus.$emit('flash-message', {message: 'API Clients reloaded...'});
                            }
                        })
                        .catch(error => {
                            Bus.$emit('flash-message', {
                                type: 'error',
                                message: 'Oops getting API clients failed for some reason...'
                            });
                        })
                        .finally(() => {
                            this.loading = false;
                        })
                }
            }
        },

        mounted() {
            this.loadClients();
        }
    }

</script>
